import React, { useEffect } from 'react';
import Aos from 'aos';
import './SplashScreen.css';

function SplashScreen() {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <div className="splash-screen">
      <div className="logo-container" data-aos="zoom-in">
        {/* Animated Logo - Same as Sidebar */}
        <div className="flex flex-col items-center gap-6">
          {/* Icon with pulse animation */}
          <div className="relative">
            {/* Outer glow rings */}
            <div className="absolute inset-0 animate-ping opacity-20">
              <div className="w-24 h-24 bg-gradient-to-br from-primary via-primary-600 to-primary-700 rounded-2xl"></div>
            </div>
            
            {/* Main icon */}
            <div className="relative w-24 h-24 bg-gradient-to-br from-primary via-primary-600 to-primary-700 rounded-2xl flex items-center justify-center shadow-2xl shadow-primary/60 animate-bounce-slow">
              <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
              </svg>
            </div>
          </div>

          {/* Brand name */}
          <div className="text-center">
            <h1 className="text-5xl font-extrabold text-white tracking-tight mb-2">
              Inbox<span className="bg-gradient-to-r from-primary via-primary-600 to-primary-300 bg-clip-text text-transparent">IQ</span>
            </h1>
            <p className="text-xl font-medium text-white/80 animate-pulse">Client Portal</p>
          </div>

          {/* Loading indicator */}
          <div className="flex gap-2 mt-4">
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SplashScreen;